module.exports = __webpack_public_path__ + "img/home-catfood2.8a2cc540.jpg";